"use client";

import { useState } from "react";

import { Input } from "@/components/ui/input";
import { Select } from "@/components/ui/select";

// ⚠️ РАЗДЕЛ ВЫБИРАЕТСЯ ЭЛЕМЕНТОМ ПОРТАЛА, а не системным списком браузера.
// Здесь стоял `<input list=…>` с `<datalist>`: список рисовала ОС — чужой шрифт,
// чужие цвета, чужое поведение (Максим, 02.09.2026). Новый раздел всё равно
// нужно уметь заводить, поэтому в списке есть пункт «Новый раздел…», который
// превращает поле в обычный `Input` портала.
export function ВыборРаздела({ value, onChange, options }: {
  value: string; onChange: (v: string) => void; options: string[];
}) {
  const [своё, setСвоё] = useState(false);
  if (своё || (value && !options.includes(value))) {
    return (
      <Input value={value} onChange={(e) => onChange(e.target.value)} autoFocus
        placeholder="Название раздела" aria-label="Раздел"
        className="w-[200px] px-1.5 py-0.5 text-[11px]"
        onBlur={() => { if (!value.trim()) setСвоё(false); }} />
    );
  }
  return (
    <Select size="xs" className="w-[200px]" value={value} aria-label="Раздел"
      placeholder="Раздел…"
      onChange={(v) => (v === "__new__" ? setСвоё(true) : onChange(v))}
      options={[
        { value: "", label: "Без раздела" },
        ...options.map((c) => ({ value: c, label: c })),
        { value: "__new__", label: "Новый раздел…" },
      ]} />
  );
}
